// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bairun-dialog-invite-activity-add .el-form-item__label {\n  width: 140px !important;\n}\n.bairun-dialog-invite-activity-add .el-form-item__content {\n  margin-left: 140px !important;\n}\n.bairun-dialog-invite-activity-add .dialog-footer {\n  left: 0 !important;\n  right: 0 !important;\n  text-align: center !important;\n}", ""]);
// Exports
module.exports = exports;
